import * as React from 'react';
import { Input } from './input';
import { cn } from '@/lib/utils';

export interface NumberInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  onChange?: (value: number | null) => void;
  value?: number | null;
  min?: number;
  max?: number;
}

export const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
  ({ className, onChange, min, max, value, ...props }: NumberInputProps, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.replace(/[^\d]/g, '');

      if (!value) {
        onChange?.(null);
        return;
      }

      let numValue = parseInt(value);
      if (isNaN(numValue)) return;

      if (typeof min === 'number') numValue = Math.max(min, numValue);
      if (typeof max === 'number') numValue = Math.min(max, numValue);

      onChange?.(numValue);
    };

    return (
      <Input
        ref={ref}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={value?.toString() ?? ''}
        onChange={handleChange}
        className={cn('w-full', className)}
        {...props}
      />
    );
  }
);

NumberInput.displayName = 'NumberInput';
